import { render, staticRenderFns } from "./FiltersInvoice.vue?vue&type=template&id=2a67ddea&scoped=true"
import script from "./FiltersInvoice.vue?vue&type=script&lang=js"
export * from "./FiltersInvoice.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&id=2a67ddea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67ddea",
  null
  
)

export default component.exports